export default __webpack_public_path__ + "static/media/seo-call.a693824e.wav";